import './style.scss';
import { NavLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useGetTeamByKey } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';

interface IProps {}
interface IParamTypes {
  teamKey: string;
}

export const EditTeamSteps = (props: IProps) => {
  const { teamKey } = useParams<IParamTypes>();
  const { data } = useGetTeamByKey(teamKey, {
    param: {
      select: ['key', 'description', 'name', 'usersCount'],
    },
  });
  return (
    <div className="edit-team-steps">
      <div className="info-section">
        <div className="icon-wrapper">{data?.usersCount || '0'}</div>
        <div className="info">
          <h2>{data?.name}</h2>
          <p>{data?.description}</p>
        </div>
      </div>
      <div className="tabs-steps">
        <NavLink to={`/configurations/teams/details/${teamKey}`}>
          Details
        </NavLink>
        <NavLink to={`/configurations/teams/team-users/${teamKey}`}>
          Users
        </NavLink>
        <NavLink to={`/configurations/teams/team-permissions/${teamKey}`}>
          Permissions
        </NavLink>
        <NavLink to={`/configurations/teams/team-products/${teamKey}`}>
          Products
        </NavLink>
      </div>
    </div>
  );
};
